import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DropdownElement extends Component {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: (e) => e.preventDefault(),
  };

  render = () => (
    <a className="dropdown-item" href={'#dropdown'} onClick={this.props.onClick}>
      {this.props.children}
    </a>
  );
}

export default DropdownElement;



// WEBPACK FOOTER //
// src/modules/common/components/DropdownElement.js